import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Activity, Wind, Moon, Heart, Zap } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const ServicesSection = () => {
  const { t } = useLanguage();

  const services = [
    {
      icon: Activity,
      title: t('services.chronicPain'),
      description: t('services.chronicPainDesc'),
      className: 'md:col-span-2',
    },
    {
      icon: Wind,
      title: t('services.sinus'),
      description: t('services.sinusDesc'),
      className: '',
    },
    {
      icon: Moon,
      title: t('services.sleep'),
      description: t('services.sleepDesc'),
      className: '',
    },
    {
      icon: Heart,
      title: t('services.perimenopause'),
      description: t('services.perimenopauseDesc'),
      className: '',
    },
    {
      icon: Zap,
      title: t('services.energy'),
      description: t('services.energyDesc'),
      className: '',
    },
  ];

  return (
    <section 
      id="services"
      className="section-padding bg-earth/30 relative overflow-hidden"
      aria-labelledby="services-title"
    >
      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-sage/5 rounded-full blur-3xl"></div>
      
      <div className="container-main relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span 
            className="inline-block font-body text-sm uppercase tracking-widest font-semibold text-sage mb-4"
            data-testid="services-caption"
          >
            {t('services.caption')}
          </span>
          <h2 
            id="services-title"
            className="font-heading text-4xl md:text-5xl font-semibold text-[#1C1C1E] tracking-tight"
            data-testid="services-title"
          >
            {t('services.title')}
          </h2>
        </div>

        {/* Bento Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <Card 
              key={index}
              className={`service-card border-earth-dark group hover:-translate-y-1 transition-transform duration-300 ${service.className}`}
              data-testid={`service-card-${index}`}
            >
              <CardContent className="p-8">
                <div className="flex items-start gap-5">
                  <div className="flex-shrink-0 w-14 h-14 bg-sage rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <service.icon className="w-7 h-7 text-white" aria-hidden="true" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-heading text-xl md:text-2xl font-semibold text-[#1C1C1E] mb-3">
                      {service.title}
                    </h3>
                    <p className="font-body text-muted-foreground leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
